module.exports = __webpack_public_path__ + "static/media/29ADMSPC1.3efc27f4.jpg";